import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { GetAllNotProcessingRows, IdentificationBoardProcessingNotification, resetGetAllStatus } from "./slice"
import Button from "../../../../ui/molecules/button"
import { PrinterIcon } from "../../../../ui/icons/PrinterIcon"

export function PreparazioneList() {

    const dispatch = useAppDispatch()
    const processingState = useAppSelector(state => state.notificationProcessing)
    const notificationState = useAppSelector(state => state.notification)

    useEffect(() => {
        dispatch(GetAllNotProcessingRows({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
    }, [])

    useEffect(() => {
        if (processingState.getAllProcessingRowsStatus === 'successfully') {
            dispatch(resetGetAllStatus())
        }
    }, [processingState.getAllProcessingRowsStatus])


    return (
        <div style={{ padding: '24px' }}>
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">N. UP</th>
                        <th className="width-[130px]">Filiera</th>
                        <th className="width-[100px]">Attività</th>
                        <th className="width-[130px]">Origine Materia Prima</th>
                        <th className="width-[130px]">Tipo Lavorazione</th>
                        <th className="width-[130px]">Separazione</th>
                        <th className="width-[130px]">C/Terzi</th>
                        <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        processingState.GetAllProcessingRowsResponse?.data.map((p, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td></td>
                                <td>{p.productiveUnitNumber}</td>
                                <td>{p.productionChain}</td>
                                <td>{p.activity}</td>
                                <td>{p.rawMaterialOrigin}</td>
                                <td>{p.processingMethod}</td>
                                <td>{p.separation}</td>
                                <td>{p.subcontracting}</td>
                                <td></td>
                            </tr>
                        )}
                </tbody>
            </table>
            <div className="mt-8">
                <Button
                    color="orange"
                    variant="solid"
                    iconPosition="left"
                    icon={<PrinterIcon color="#fff" />}
                    size="md"
                    label="Scheda ident."
                    onClick={() => {
                        dispatch(IdentificationBoardProcessingNotification(notificationState.notificationIdToUpdate))
                    }}
                />
            </div>
        </div>
    )
}